<template>
  <div class="d-flex justify-content-center">
    <AppDatePicker
      ref="datepicker"
      v-model="selected"
      range
      range-separator="-"
      :shortcuts="shortcuts"
      :disabled-date="disabledDates"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      @calendar-change="onCalChange"
    >
      <template v-if="!isWeeklyDaterangePicker" #footer>
        <AppDatePickerShortcuts :jahr="calendarSelectedYear" @select="bereichWaehlen" />
      </template>
    </AppDatePicker>
  </div>
</template>
<script>
import AppDatePicker from '@/components/common/app-date-picker/app-date-picker.vue';
import AppDatePickerShortcuts from '@/components/common/app-date-picker/app-date-picker-shortcuts.vue';

export default {
  name: 'DateRangePicker',
  components: { AppDatePicker, AppDatePickerShortcuts },
  props: {
    value: { type: Object },
    placeholder: { type: String, default: '' },
    isWeeklyDaterangePicker: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      selected: null,
      shortcuts: this.isWeeklyDaterangePicker
        ? []
        : [
            {
              text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.HEUTE'),
              onClick: () => {
                const date = new Date();
                this.calendarSelectedYear = date.getFullYear();
                return [date, date];
              },
            },
            {
              text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.JAHRESENDE'),
              onClick: () => {
                const start = new Date();
                const end = new Date(new Date().getFullYear(), 11, 31);
                this.calendarSelectedYear = start.getFullYear();
                return [start, end];
              },
            },
            {
              text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.ANFANGJAHR'),
              onClick: () => {
                const start = new Date(new Date().getFullYear(), 0, 1);
                this.calendarSelectedYear = start.getFullYear();
                return [start, start];
              },
            },
            {
              text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.INMONATE'),
              onClick: () => {
                const start = new Date();
                const newDate = new Date();
                const end = new Date(newDate.setMonth(newDate.getMonth() + 3));
                this.calendarSelectedYear = start.getFullYear();
                return [start, end];
              },
            },
          ],
      calendarSelectedYear: new Date().getFullYear(),
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newDate) {
        this.selected = newDate
          ? newDate.start && newDate.end
            ? [new Date(newDate.start), new Date(newDate.end)]
            : newDate.start && !newDate.end
            ? [new Date(newDate.start), new Date(newDate.start)]
            : !newDate.start && newDate.end
            ? [new Date(newDate.end), new Date(newDate.end)]
            : []
          : [];
      },
    },
  },
  methods: {
    onCalChange(date) {
      this.calendarSelectedYear = date.getFullYear();
    },
    onInput($event) {
      this.$emit(
        'input',
        this.$options.filters.dateNumeric($event[0]),
        $event[0] === $event[1] ? null : this.$options.filters.dateNumeric($event[1])
      );
    },
    // Monats-, Quartals- oder Jahresauswahl aus dem Footer übernehmen
    bereichWaehlen([von, bis]) {
      this.$refs.datepicker.closePopup();
      this.calendarSelectedYear = von.getFullYear();
      this.selected = [von, bis];
      this.onInput(this.selected);
    },
    disabledDates(date) {
      const day = new Date(date).getDay();
      if (this.isWeeklyDaterangePicker) return day !== 6;
      else return;
    },
  },
};
</script>
